import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../../components/form/CustomInput";
import CustomSelect from "../../../components/form/CustomSelect";
import CustomButton from "../../../components/form/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import { update_load } from "../../../store/loads/action";
import { clientsResource, getScheduls, getStatuses, trailerTrucksResource, usersResource } from "../../../helpers/configRoutes/backend_helper";
import { showFormErrors } from "../../../helpers/showFormErrors";
import LoadConceptPayments from "../payments/LoadConceptPayments";
import { currencyUSD } from "../../../helpers/forms/formater";

const StepOne = ({
    onNext,
    onCancel
}) => {
    const dispatch = useDispatch()
    const { load, validationStepOne } = useSelector((state) => state.Load)

    //Catalogos para select
    const [clients, setClients] = useState([]);
    const [statuses, setStatuses] = useState([]);
    const [loadSchedules, setLoadSchedules] = useState([]);
    const [operators, setOperators] = useState([]);
    const [trucks, setTrucks] = useState([]);
    const [trailers, setTrailers] = useState([]);

    useEffect(() => {
        const getCatalogs = async () => {
            try {
                const trucksResponse = await trailerTrucksResource("get", {
                    params: { select: true, truck: true },
                });
                if (trucksResponse?.items) setTrucks(trucksResponse.items);

                const trailerResponse = await trailerTrucksResource("get", {
                    params: { select: true },
                });
                if (trailerResponse?.items) setTrailers(trailerResponse.items);

                const operatorsResponse = await usersResource("get", {
                    params: { operator: true, select: true, load: true },
                });
                if (operatorsResponse?.users) setOperators(operatorsResponse.users);

                const statusesResponse = await getStatuses({
                    params: { model: "Load" },
                });
                if (statusesResponse?.statuses)
                    setStatuses(statusesResponse.statuses);

                const schedulsResponse = await getScheduls();
                if (schedulsResponse?.scheduls)
                    setLoadSchedules(schedulsResponse.scheduls);

                const clientsResponse = await clientsResource("get", {
                    params: { select: true },
                });
                if (clientsResponse?.clients) setClients(clientsResponse.clients);
            } catch (e) {
                console.error("Error loading catalogs", e);
            }
        };
        getCatalogs();
    }, []);

    const validation = useFormik({
        initialValues: load,
        enableReinitialize: false,
        validationSchema: Yup.object(validationStepOne),
        onSubmit: (values, { setErrors }) => {
            dispatch(update_load(values))
            onNext()
        },
    });

    const { values, errors, handleChange } = validation;


    useEffect(() => {
        const getMilesTruck = async () => {
            if (validation.values.truck_id) {
                const response = await trailerTrucksResource(
                    "show",
                    {},
                    validation.values.truck_id
                );
                if (response?.items?.current_mileage !== undefined) {
                    validation.setFieldValue(
                        "current_mileage_truck",
                        response.items.current_mileage,
                        false
                    );
                }
            }
        };
        getMilesTruck();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [validation.values.truck_id]);

    useEffect(() => {
        if (!values.payments || !values.payments.length) {
            validation.setFieldValue('charges', 0, false);
            return;
        }


        const total = values.payments.reduce((sum, p) => {
            const amount = parseFloat(p.amount) || 0;
            return sum + amount;
        }, 0);


        validation.setFieldValue('charges', total, false);
    }, [values.payments]); // 👈 clave


    return (
        <>
            <form
                onSubmit={(e) => {
                    console.log(values, 'values')
                    e.preventDefault();
                    validation.handleSubmit();
                    showFormErrors(validation);
                    return false;
                }}
                className="space-y-4"
            >
                <div className="space-y-6">

                    {/* Título del paso */}
                    <div>
                        <h2 className="text-lg font-semibold text-cs-dark">
                            Load & equipment
                        </h2>
                        <p className="text-sm text-cs-muted mt-1">
                            Define client, charges and assign truck / trailer / operator.
                        </p>
                    </div>

                    {/* LOAD DETAILS */}
                    <div className="space-y-3">
                        <h3 className="text-xs font-semibold text-cs-muted uppercase tracking-wide">
                            Load details
                        </h3>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <CustomSelect
                                label="Client"
                                options={clients}
                                name="client_id"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={errors.client_id}
                                value={values.client_id}
                                handleChange={handleChange}
                            />

                            <CustomSelect
                                label="Status"
                                options={statuses}
                                name="status_id"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={errors.status_id}
                                value={values.status_id}
                                handleChange={handleChange}
                            />

                            <CustomSelect
                                label="Load schedule"
                                options={loadSchedules}
                                name="schedule_id"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={errors.schedule_id}
                                value={values.schedule_id}
                                handleChange={handleChange}
                            />
                        </div>
                    </div>

                    {/* EQUIPMENT */}
                    <div className="space-y-3">
                        <h3 className="text-xs font-semibold text-cs-muted uppercase tracking-wide">
                            Equipment
                        </h3>

                        {/* Fila 1: operador + truck + mileage truck */}
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                            <div className="md:col-span-1">
                                <CustomSelect
                                    label="Operator"
                                    options={operators}
                                    name="operator_id"
                                    labelClassName="text-xs font-medium text-cs-dark"
                                    error={errors.operator_id}
                                    value={values.operator_id}
                                    handleChange={handleChange}
                                />
                            </div>

                            <CustomSelect
                                label="Truck"
                                options={trucks}
                                name="truck_id"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={errors.truck_id}
                                value={values.truck_id}
                                handleChange={handleChange}
                            />
                            <CustomSelect
                                label="Trailer"
                                options={trailers}
                                name="trailer_id"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={errors.trailer_id}
                                value={values.trailer_id}
                                handleChange={handleChange}
                            />
                            <CustomInput
                                label="Mileage (truck)"
                                type="text"
                                name="current_mileage_truck"
                                labelClassName="text-xs font-medium text-cs-dark"
                                error={errors.current_mileage_truck}
                                value={values.current_mileage_truck}
                                handleChange={handleChange}
                            />
                        </div>
                        <LoadConceptPayments load={validation} />
                        <div className="flex justify-end mt-4">
                            <div className="bg-gray-50 border rounded-lg px-4 py-2 text-sm">
                                <span className="text-cs-muted">Total load:</span>
                                <span className="ml-2 font-semibold text-cs-dark">
                                    {currencyUSD(values.charges)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mt-6 pt-4 border-t border-cs-border">
                    <div className="text-xs text-cs-muted">
                        Step 1 of 3 – Basic load info.
                    </div>
                    <div className="flex justify-end gap-3">
                        <CustomButton
                            type="button"
                            onClick={onCancel}
                            className="
              inline-flex items-center gap-2
              px-4 py-2.5
              rounded-xl
              bg-cs-danger hover:bg-cs-primary-hover
              text-white text-sm font-medium
              shadow-md hover:shadow-lg
              transition-all
            "
                        >
                            Cancel
                        </CustomButton>

                        <CustomButton
                            type={"submit"}
                            className="
              inline-flex items-center gap-2
              px-4 py-2.5
              rounded-xl
              bg-cs-primary hover:bg-cs-primary-hover
              text-white text-sm font-medium
              shadow-md hover:shadow-lg
              transition-all
            "
                        >
                            Next step
                            <span className="material-symbols-outlined text-sm">
                                arrow_forward
                            </span>
                        </CustomButton>
                    </div>

                </div>
            </form>
        </>
    );
};

export default StepOne;
